export interface VideoItem {
  id: string;
  title: string;
  slug: string;
  category: 'jq' | 'jl' | 'zy' | 'dp';
  categoryName: string;
  thumbnail: string;
  duration: string;
  description: string;
  publishDate: string;
  viewCount: number;
  rating: number;
  tags: string[];
  featured: boolean;
  hot: boolean;
}

export const categories = [
  { slug: 'jq', name: '剧情', nameEn: 'Drama', description: '精选国产剧情片，讲述动人故事，展现人生百态' },
  { slug: 'jl', name: '纪录', nameEn: 'Documentary', description: '真实纪录中国故事，探索社会人文与自然之美' },
  { slug: 'zy', name: '综艺', nameEn: 'Variety', description: '精彩综艺节目，欢乐与感动并存的视听盛宴' },
  { slug: 'dp', name: '短片', nameEn: 'Short Film', description: '创意短片精选，浓缩的艺术表达与思想碰撞' },
];

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '山河故人',
    slug: 'shan-he-gu-ren',
    category: 'jq',
    categoryName: '剧情',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20film%20scene%20with%20warm%20nostalgic%20lighting%2C%20two%20figures%20standing%20in%20a%20misty%20mountain%20landscape%20at%20sunset%2C%20cinematic%20composition%2C%20soft%20golden%20hour%20light%2C%20emotional%20atmosphere%2C%20artistic%20photography%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=vid-jq-001&orientation=landscape',
    duration: '2:15:30',
    description: '一段跨越三十年的情感纠葛，在时代变迁中，每个人都在寻找属于自己的归宿。影片以细腻的镜头语言，描绘了普通人在大时代背景下的命运浮沉。从黄土高原到现代都市，三代人的故事交织成一幅宏大的时代画卷。',
    publishDate: '2025-12-15',
    viewCount: 1285000,
    rating: 9.2,
    tags: ['剧情', '文艺', '时代变迁', '情感'],
    featured: true,
    hot: true,
  },
  {
    id: 'v002',
    title: '城市之光',
    slug: 'cheng-shi-zhi-guang',
    category: 'jl',
    categoryName: '纪录',
    thumbnail: 'https://readdy.ai/api/search-image?query=Documentary%20photography%20style%20of%20modern%20Chinese%20city%20skyline%20at%20dusk%2C%20warm%20ambient%20light%2C%20urban%20architecture%20silhouettes%2C%20people%20walking%20on%20busy%20street%2C%20cinematic%20documentary%20aesthetic%2C%20rich%20contrast%20and%20deep%20shadows&width=800&height=450&seq=vid-jl-001&orientation=landscape',
    duration: '1:28:00',
    description: '深入探访中国五座城市的变迁历程，记录城市化进程中的人文故事。从老城区的街头巷尾到新城的摩天大楼，本片以独特的视角展现了城市发展与人文传承的平衡之道。',
    publishDate: '2025-11-20',
    viewCount: 956000,
    rating: 9.0,
    tags: ['纪录', '城市', '人文', '社会'],
    featured: true,
    hot: true,
  },
  {
    id: 'v003',
    title: '欢乐集结号',
    slug: 'huan-le-ji-jie-hao',
    category: 'zy',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20warm%20stage%20lighting%2C%20hosts%20interacting%20energetically%20on%20a%20modern%20TV%20set%2C%20bright%20and%20vibrant%20atmosphere%2C%20professional%20studio%20photography%2C%20cheerful%20and%20lively%20mood&width=800&height=450&seq=vid-zy-001&orientation=landscape',
    duration: '1:05:20',
    description: '年度最受欢迎的综艺节目，汇聚各路明星嘉宾，带来欢笑与感动。每期邀请不同领域的嘉宾，通过趣味游戏和深度访谈，展现他们鲜为人知的一面。',
    publishDate: '2026-01-08',
    viewCount: 2350000,
    rating: 9.5,
    tags: ['综艺', '娱乐', '明星', '访谈'],
    featured: true,
    hot: true,
  },
  {
    id: 'v004',
    title: '归途',
    slug: 'gui-tu',
    category: 'dp',
    categoryName: '短片',
    thumbnail: 'https://readdy.ai/api/search-image?query=Artistic%20short%20film%20scene%20of%20a%20lone%20traveler%20on%20a%20winding%20country%20road%20during%20golden%20hour%2C%20surrounded%20by%20autumn%20trees%2C%20warm%20nostalgic%20tones%2C%20minimalist%20cinematic%20composition%2C%20evocative%20and%20contemplative%20mood&width=800&height=450&seq=vid-dp-001&orientation=landscape',
    duration: '0:18:45',
    description: '一部关于回家的短片，用诗意的画面讲述了一个年轻人在春节前夕的归乡旅程。十八分钟的影像里，浓缩了乡愁、亲情与对未来的思考。',
    publishDate: '2026-02-01',
    viewCount: 680000,
    rating: 8.8,
    tags: ['短片', '情感', '春节', '乡愁'],
    featured: false,
    hot: true,
  },
  {
    id: 'v005',
    title: '大江大河',
    slug: 'da-jiang-da-he',
    category: 'jq',
    categoryName: '剧情',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20with%20vast%20river%20landscape%2C%20small%20figures%20on%20riverbank%2C%20dramatic%20cloudy%20sky%2C%20warm%20earthy%20tones%2C%20cinematic%20widescreen%20composition%2C%20powerful%20and%20emotional%20atmosphere&width=800&height=450&seq=vid-jq-002&orientation=landscape',
    duration: '2:30:00',
    description: '以改革开放为背景，讲述了几个年轻人在时代浪潮中奋勇前行的故事。从农村到城市，从贫困到富裕，他们的人生轨迹见证了中国的巨大变迁。',
    publishDate: '2025-10-05',
    viewCount: 1890000,
    rating: 9.3,
    tags: ['剧情', '年代', '改革开放', '励志'],
    featured: true,
    hot: false,
  },
  {
    id: 'v006',
    title: '舌尖上的记忆',
    slug: 'she-jian-shang-de-ji-yi',
    category: 'jl',
    categoryName: '纪录',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20food%20documentary%20photography%20of%20traditional%20Chinese%20kitchen%20with%20steaming%20dishes%2C%20wooden%20table%20filled%20with%20colorful%20homemade%20food%2C%20warm%20cozy%20lighting%2C%20rustic%20aesthetic%2C%20mouthwatering%20culinary%20scene&width=800&height=450&seq=vid-jl-002&orientation=landscape',
    duration: '0:52:30',
    description: '走遍大江南北，探寻每个地方独特的美食记忆。从东北的饺子到广东的早茶，每一道菜肴背后都承载着一方水土的文化与情感。',
    publishDate: '2025-09-18',
    viewCount: 1560000,
    rating: 9.1,
    tags: ['纪录', '美食', '文化', '传统'],
    featured: true,
    hot: false,
  },
  {
    id: 'v007',
    title: '才艺大舞台',
    slug: 'cai-yi-da-wu-tai',
    category: 'zy',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20performers%20under%20dramatic%20spotlights%2C%20colorful%20stage%20design%2C%20excited%20audience%20in%20background%2C%20vibrant%20concert%20atmosphere%2C%20professional%20event%20photography%2C%20energetic%20and%20dynamic%20composition&width=800&height=450&seq=vid-zy-002&orientation=landscape',
    duration: '1:15:00',
    description: '全民才艺竞技类节目，为普通人的梦想搭建舞台。来自各行各业的选手展示独特才艺，用真诚和热情打动每一位观众。',
    publishDate: '2026-03-12',
    viewCount: 3120000,
    rating: 9.4,
    tags: ['综艺', '才艺', '竞技', '梦想'],
    featured: false,
    hot: true,
  },
  {
    id: 'v008',
    title: '沉默的对白',
    slug: 'chen-mo-de-dui-bai',
    category: 'dp',
    categoryName: '短片',
    thumbnail: 'https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20short%20film%20scene%2C%20two%20elderly%20people%20sitting%20on%20a%20park%20bench%20facing%20a%20calm%20lake%2C%20autumn%20leaves%20falling%2C%20contemplative%20and%20poetic%20atmosphere%2C%20minimalist%20cinematic%20photography&width=800&height=450&seq=vid-dp-002&orientation=landscape',
    duration: '0:22:10',
    description: '一对老年夫妇的日常，没有过多的言语，却通过细微的动作和眼神传递了五十年的深情。这是一部关于爱情与陪伴的静默诗篇。',
    publishDate: '2025-08-25',
    viewCount: 420000,
    rating: 8.7,
    tags: ['短片', '爱情', '老年', '陪伴'],
    featured: false,
    hot: false,
  },
  {
    id: 'v009',
    title: '青春派',
    slug: 'qing-chun-pai',
    category: 'jq',
    categoryName: '剧情',
    thumbnail: 'https://readdy.ai/api/search-image?query=Youth%20drama%20scene%20of%20Chinese%20high%20school%20students%20laughing%20together%20on%20a%20sunny%20campus%20playground%2C%20warm%20golden%20sunlight%2C%20carefree%20and%20nostalgic%20atmosphere%2C%20natural%20photography%20style%2C%20bright%20and%20hopeful%20mood&width=800&height=450&seq=vid-jq-003&orientation=landscape',
    duration: '1:48:00',
    description: '一群高中生的青春故事，有欢笑、有泪水、有成长的烦恼。影片真实还原了当代青少年的校园生活，引发无数观众的共鸣。',
    publishDate: '2026-04-20',
    viewCount: 890000,
    rating: 8.9,
    tags: ['剧情', '青春', '校园', '成长'],
    featured: false,
    hot: true,
  },
  {
    id: 'v010',
    title: '丝绸之路新篇章',
    slug: 'si-chou-zhi-lu-xin-pian-zhang',
    category: 'jl',
    categoryName: '纪录',
    thumbnail: 'https://readdy.ai/api/search-image?query=Documentary%20scene%20of%20ancient%20Silk%20Road%20desert%20landscape%20with%20camel%20caravan%20silhouette%20at%20sunset%2C%20warm%20golden%20sand%20dunes%2C%20vast%20and%20majestic%20composition%2C%20historical%20and%20cultural%20atmosphere%2C%20cinematic%20documentary%20aesthetic&width=800&height=450&seq=vid-jl-003&orientation=landscape',
    duration: '1:40:00',
    description: '从西安到罗马，沿着古丝绸之路的足迹，探寻千年文明的交汇。本片通过实地拍摄和专家访谈，展现了丝绸之路经济带建设给沿线带来的新机遇。',
    publishDate: '2025-07-10',
    viewCount: 1120000,
    rating: 9.0,
    tags: ['纪录', '历史', '丝绸之路', '文化'],
    featured: false,
    hot: false,
  },
  {
    id: 'v011',
    title: '星光音乐会',
    slug: 'xing-guang-yin-yue-hui',
    category: 'zy',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20music%20concert%20at%20night%20with%20colorful%20stage%20lights%20and%20large%20enthusiastic%20crowd%2C%20performers%20on%20stage%2C%20starry%20sky%20above%2C%20festive%20and%20magical%20atmosphere%2C%20vibrant%20event%20photography&width=800&height=450&seq=vid-zy-003&orientation=landscape',
    duration: '1:20:00',
    description: '户外音乐综艺，邀请知名音乐人在星空下演绎经典歌曲。每期选择不同的自然场景，将音乐与大自然完美融合，带来极致的视听享受。',
    publishDate: '2026-05-15',
    viewCount: 2780000,
    rating: 9.6,
    tags: ['综艺', '音乐', '户外', '演唱会'],
    featured: true,
    hot: true,
  },
  {
    id: 'v012',
    title: '纸飞机',
    slug: 'zhi-fei-ji',
    category: 'dp',
    categoryName: '短片',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20child%20releasing%20a%20paper%20airplane%20from%20a%20rooftop%20overlooking%20a%20small%20Chinese%20town%20at%20sunset%2C%20warm%20golden%20light%2C%20dreamy%20and%20hopeful%20atmosphere%2C%20poetic%20short%20film%20aesthetic%2C%20minimalist%20composition&width=800&height=450&seq=vid-dp-003&orientation=landscape',
    duration: '0:15:30',
    description: '一个小男孩折了一架纸飞机，飞越了整个小镇。这部充满想象力的短片，用温柔的视角展现了童年的纯真与梦想的力量。',
    publishDate: '2026-01-30',
    viewCount: 350000,
    rating: 8.6,
    tags: ['短片', '童年', '梦想', '温情'],
    featured: false,
    hot: false,
  },
];

export const getVideosByCategory = (categorySlug: string): VideoItem[] => {
  return videos.filter((v) => v.category === categorySlug);
};

export const getFeaturedVideos = (): VideoItem[] => {
  return videos.filter((v) => v.featured);
};

export const getHotVideos = (): VideoItem[] => {
  return videos.filter((v) => v.hot);
};

export const getVideoById = (id: string): VideoItem | undefined => {
  return videos.find((v) => v.id === id);
};

export const getRelatedVideos = (video: VideoItem, limit: number = 4): VideoItem[] => {
  return videos
    .filter((v) => v.id !== video.id && v.category === video.category)
    .slice(0, limit);
};